// Pop-up: the tips or invoices behind one customer's number.
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.
import { fmtMoneyRounded as fmtMoney } from '../../utils/money.js';

export default function DrillModal({ drill, setDrill }) {
  return (
    <>
      {drill && (
        <div className="modal-backdrop" onClick={() => setDrill(null)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 720, maxWidth: '95vw', maxHeight: '85vh', overflowY: 'auto' }}>
            <h3>{drill.customer} — {drill.type === 'tips' ? 'Tips in period' : 'Invoices in period'}</h3>
            {drill.type === 'tips' && (() => {
              // Split into approved + pending so they show as separate
              // labeled sections. Both share the same columns.
              const approved = drill.rows.filter(r => !r._pending);
              const pending  = drill.rows.filter(r => r._pending);
              const renderTable = (rows, label, bgColor) => (
                <table className="fs-table tidy" style={{ marginTop: '0.5rem' }}>
                  <thead>
                    <tr style={{ background: bgColor }}>
                      <th colSpan="5" style={{ textAlign: 'left', padding: '0.4rem 0.6rem' }}>{label} <span className="small" style={{ color: '#666' }}>({rows.length})</span></th>
                    </tr>
                    <tr><th>Date</th><th>Time</th><th>Plate</th><th>Size</th><th className="num">Rate</th></tr>
                  </thead>
                  <tbody>
                    {rows.length === 0 && <tr><td colSpan="5" style={{ textAlign: 'center', padding: '0.6rem', color: '#888' }}>None.</td></tr>}
                    {rows.map((r, i) => (
                      <tr key={r.id || (label + i)} style={r._pending ? { background: '#fffbeb' } : {}}>
                        <td>{r.date}</td>
                        <td className="small">{r.time}</td>
                        <td><code>{r.plate}</code></td>
                        <td>{r.tankSize}m³ <span className="small" style={{ color: '#888' }}>({r.sizeBucket})</span></td>
                        <td className="num">{fmtMoney(r.rate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              );
              return (
                <>
                  {renderTable(approved, '✓ Approved tips', '#dcfce7')}
                  {pending.length > 0 && renderTable(pending, '⏳ Pending approval', '#fef3c7')}
                </>
              );
            })()}
            {drill.type === 'invoices' && (
              drill.rows.map(inv => (
                <div key={inv.id} className="card" style={{ padding: '0.5rem 0.75rem', marginTop: '0.5rem', background: '#fafafa' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <strong>Invoice #{inv.number || inv.id}</strong>
                    <span className="small">{inv.date} · Total <strong>{fmtMoney(inv.totalAmt)}</strong> · Balance {fmtMoney(inv.balance)}</span>
                  </div>
                  <div className="small" style={{ color: '#16a34a', marginTop: 2 }}>
                    Disposal Fees (B+N): <strong>{fmtMoney(inv.disposalFeesTotal)}</strong>
                  </div>
                  {inv.other.length > 0 && (
                    <table className="fs-table tidy" style={{ marginTop: '0.4rem' }}>
                      <thead><tr><th>Other line item</th><th>Description</th><th className="num">Amount</th></tr></thead>
                      <tbody>
                        {inv.other.map((o, i) => (
                          <tr key={i}><td>{o.product || '—'}</td><td className="small">{o.description || ''}</td><td className="num">{fmtMoney(o.amount)}</td></tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              ))
            )}
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
              <button className="refresh-btn" onClick={() => setDrill(null)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
